import React, { useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import "./app-layout.scss";

const menuItems = [
  { label: "Dashboard", icon: "▦", path: "/admin" },
  { label: "Products", icon: "□", path: "/admin/products" },
  { label: "Articles", icon: "▤", path: "/admin/articles" },
  { label: "Users", icon: "♙", path: "/admin/users" },
  { label: "Settings", icon: "⚙", path: "/admin/settings" },
  { label: "Audit Trail", icon: "≣", path: "/admin/audit-trail" },
];

const pageTitles = {
  "/admin": ["Overview", "Dashboard"],
  "/admin/products": ["Storefront Management", "Products"],
  "/admin/articles": ["Content Management", "Articles"],
  "/admin/users": ["Administration", "Users"],
  "/admin/settings": ["Administration", "Website Settings"],
  "/admin/audit-trail": ["Administration", "Audit Trail"],
};

const AppLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [eyebrow, title] = location.pathname.startsWith("/admin/products/")
    ? ["Storefront Management", "Edit Product Details"]
    : pageTitles[location.pathname] || pageTitles["/admin"];

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <div className="app-layout">
      <aside className={`app-layout__sidebar ${sidebarOpen ? "app-layout__sidebar--open" : ""}`}>
        <div className="app-layout__brand">
          <div className="app-layout__wordmark">
            <span>興和利貿易有限公司</span>
            <strong>Hin Ho Lee Trading Sdn. Bhd.</strong>
          </div>
          <span>ADMIN PORTAL</span>
        </div>

        <nav className="app-layout__menu">
          <p className="app-layout__nav-label">MANAGEMENT</p>
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/admin"}
              className={({ isActive }) =>
                `app-layout__menu-item ${isActive ? "app-layout__menu-item--active" : ""}`
              }
              onClick={() => setSidebarOpen(false)}
            >
              <span className="app-layout__menu-icon">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <button className="app-layout__logout" type="button" onClick={handleLogout}>Log out</button>
      </aside>

      {sidebarOpen && <button className="app-layout__overlay" type="button" aria-label="Close menu" onClick={() => setSidebarOpen(false)} />}

      <main className="app-layout__main">
        <header className="app-layout__topbar">
          <button className="app-layout__menu-toggle" type="button" aria-label="Open menu" onClick={() => setSidebarOpen(true)}>☰</button>
          <div className="app-layout__heading">
            <p className="app-layout__eyebrow">{eyebrow}</p>
            <h1 className="app-layout__title">{title}</h1>
          </div>
          <div className="app-layout__profile"><span className="app-layout__avatar">AL</span><span><strong>Admin Lee</strong><small>Super Administrator</small></span></div>
        </header>
        <section className="app-layout__content"><Outlet /></section>
      </main>
    </div>
  );
};

export default AppLayout;
